import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RouteIdResolveService implements Resolve<string> {
    constructor() {}
    resolve(
        route: ActivatedRouteSnapshot,
    ): string | Observable<string> | Promise<string> {
        return route.params['id'];
    }
}
